export default {
  data() {
    return {
      basePageLoaded: false,
    };
  },
  computed: {
    availableAlgorithms: {
      cache: false,
      get() {
        const algorithms = this.$store.getters.org.algorithmConfig.algorithms;
        let hasSingle, hasMulti;
        algorithms.forEach((algo) => {
          if (algo.name.indexOf('default') !== -1) hasSingle = true;
          if (algo.name.indexOf('conversational') !== -1) hasMulti = true;
        });
        return {
          default: hasSingle,
          conversational: hasMulti,
        };
      }
    },
    feedback() {
      return this.$store.getters.feedback;
    },
    isOrgLevelAdmin() {
      return (this.$store.getters.org && this.$store.getters.org.roles && this.$store.getters.org.roles.indexOf('admin') !== -1);
    },
    isOrgLevelManager() {
      return (this.$store.getters.org && this.$store.getters.org.roles && this.$store.getters.org.roles.indexOf('manager') !== -1);
    },
    isEdu() {
      return this.$store.getters.org && this.$store.getters.org.type == 'edu';
    },
    isGroupManager() {
      return this.managedGroups.length > 0 ||
        (this.$store.getters.org && this.$store.getters.org.roles && this.$store.getters.org.roles.indexOf('manager') !== -1);
    },
    isSpeaker() {
      return this.speakerGroups.length > 0;
    },
    showEmailNotifications() {
      const org = this.$store.getters.org;
      return (org && typeof org.settings !== 'undefined' &&
        ((this.isSpeaker && org.settings.Email_Notifications_For_Speakers) ||
          (this.isGroupManager && org.settings.Email_Notifications_For_Managers)));
    },
    groupMembers: {
      cache: false,
      get() {
        return this.$store.getters.groupMembers;
      }
    },
    sharedRecordings: {
      cache: false,
      get() {
        return this.$store.getters.groupRecordings;
      }
    },
    homepage: {
      cache: false,
      get() {
        if (this.assignmentsEnabled) {
          if (this.managedGroups.length > 0) {
            return 'coach-dashboard';
          }
          if (this.isSpeaker) {
            return 'speaker-dashboard';
          }
        }
        if (this.isOrgLevelAdmin) {
          return 'customer-admin-groups';
        }
        if (this.isGroupManager) {
          return 'manage';
        }
        if (this.isSpeaker) {
          return 'evaluate';
        }
        return 'subscription';
      }
    },
    org() {
      return this.$store.getters.org;
    },
    orgType() {
      return this.$store.getters.org && this.$store.getters.org.type;
    },
    managedGroups: {
      cache: false,
      get() {
        return this._.filter(this.$store.getters.activeGroups, group => {
          return this._.includes(group.roles, 'manager');
        });
      }
    },
    speakerGroups: {
      cache: false,
      get() {
        return this._.filter(this.$store.getters.activeGroups, group => {
          return this._.includes(group.roles, 'speaker');
        });
      }
    },
    isOrgExpiration: {
      cache: false,
      get() {
        return this.org && this.org.billingModel && this.org.billingModel == 1;
      }
    },
    activeGroups: {
      cache: false,
      get() {
        return this.$store.getters.activeGroups;
      }
    },
    assignmentsEnabled() {
      return (this.org && typeof this.org.settings !== 'undefined' && this.org.settings.Assignments);
    },
    me: {
      cache: false,
      get() {
        return this.$store.getters.user;
      }
    },
    preferences: {
      cache: false,
      get() {
        return this.$store.getters.preferences;
      }
    },
    currentMode: {
      cache: false,
      get() {
        return (this.$store.getters.currentMode) ?
          this.$store.getters.currentMode : null;
      }
    },
    pageMode: {
      cache: false,
      get() {
        return (this.assignmentsEnabled) ? this.currentMode :
          (this.isGroupManager) ? 'manager' : 'speaker';
      }
    },
  },
  methods: {
    isManagerOf(groupId) {
      return !!(this._.find(this.managedGroups, {groupId}));
    },
    setCurrentAssignment() {
      const curr =
        _.cloneDeep(_.find(
          this.assignments,
          s => s.assignmentId === this.$router.currentRoute.params.assignmentId
        ));
      if (curr && typeof curr.name !== 'undefined') {
        this.assignment = curr;
      } else {
        // Create a new assignment
        this.assignment = {
          name: '',
          description: '',
          isShared: false,
          isTemplate: false,
          criteria: {},
          attachments: [],
        };
      }
    },
    setCurrentAssignmentFromUrl() {
      const curr =
        _.cloneDeep(_.find(
          this.augmentedAssignments,
          s => s.assignmentId === this.$router.currentRoute.params.assignmentId
        ));
      if (curr && typeof curr.name !== 'undefined') {
        this.assignment = curr;
        return true;
      }
      return false;
    },
    loadTab(identifier, evt) {
      if (evt && evt.key && evt.key === 'Tab') {
        // Firefox bug fix
        return true;
      }

      this.tab = identifier;

      const link = this.$refs[identifier.replace(/ /g, '') + 'link'];
      link.blur();
      const header = this.$refs[identifier.replace(/ /g, '') + 'header'];
      if (header) {
        header.focus();
      }

      // Fix identifier for announcer for non-EDU
      if (identifier === 'my classes' && !this.isEdu) {
        identifier = 'my groups';
      }

      this.$announcer.set(`The ${identifier} tab has been activated. The associated page content is now available below.`);
    },
  },
  created() {
    if (typeof this.topLevelPage !== 'undefined' && this.topLevelPage === false) {
      return true;
    }

    // Don't reload groups unless you need to
    /* Let's wait to add this in. Don't rock the boat...
    if (this.activeGroups && this.activeGroups.length) {
      this.basePageLoaded = true;
      if (typeof this.basePageCreated !== 'undefined') {
        this.basePageCreated();
      }
      return true;
    }
    */

    this.basePageLoaded = false;
    this.$store.dispatch('listGroups')
      .then(() => {
        this.basePageLoaded = true;
        if (typeof this.basePageCreated !== 'undefined') {
          this.basePageCreated();
        }
      });
  },
};
